// extracted by mini-css-extract-plugin
export default {"timeDisplay":"time-display_timeDisplay__rRaI8"};